import { createSelector } from 'reselect';
import { socialSharesSelector } from 'redux/modules/entities';
import { PostStatus } from '../constants';
import { stateSelector } from '../selectors';

export const blueskySelector = createSelector(stateSelector, state =>
  state.get('bluesky'),
);

export const blueskyUsernameSelector = createSelector(
  blueskySelector,
  bluesky => bluesky.username,
);

export const blueskyAvatarSrcSelector = createSelector(
  blueskySelector,
  bluesky => bluesky.profileImageUrl,
);

export const blueskySocialShareIdSelector = createSelector(
  blueskySelector,
  bluesky => bluesky.socialShareId,
);

export const blueskyProviderUserIdSelector = createSelector(
  blueskySelector,
  bluesky => bluesky.providerUserId,
);

export const blueskyUserDataSelector = createSelector(
  blueskySelector,
  bluesky => ({
    accessToken: bluesky.accessToken,
    idToken: bluesky.idToken,
    providerUserId: bluesky.providerUserId,
    accessTokenSecret: bluesky.accessTokenSecret,
  }),
);

export const blueskySocialSharesSelector = createSelector(
  blueskySocialShareIdSelector,
  socialSharesSelector,
  (id, shares) =>
    !id || !shares || shares.size === 0
      ? undefined
      : shares.get(String(id))?.toJS(),
);

export const blueskyPostStatusSelector = createSelector(
  blueskySelector,
  bluesky => bluesky.postStatus,
);

export const blueskyIsPostingSelector = createSelector(
  blueskyPostStatusSelector,
  postStatus => postStatus === PostStatus.IN_PROGRESS,
);

export const isLoadingBlueskyUserSelector = createSelector(
  blueskySelector,
  bluesky => bluesky.isLoadingUser,
);
